<div class="widget">
  <div class="amSuite-widget-header">
    {{'widgets.activity-graphs.state-graph.title' | translate}}
    @if (modify) {
      <a href="javascript:void(0)" (click)="actpop()" class="modify-btn"
        pTooltip="{{'widgets.user-activities.edit' | translate}}">
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      </a>
    }
    @if (!modify) {
      <small class="date-font"><i>({{initialDate | date: 'shortDate'}} -
      {{finalDate | date:'shortDate'}})</i></small>
    }
  </div>
  <div class="graph-widget amSuite-widget-block height-auto">
    @switch (status) {
      @case ('ready') {
        <div>
          <p-chart type="doughnut" [data]="dataOfState" height="200px" [options]="graphOptions"></p-chart>
        </div>
      }
      @case ('busy') {
        <div>
          <p>
            <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
          </p>
        </div>
      }
    }
  </div>
</div>
